"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NavBar = _interopRequireDefault(require("../NavBar/NavBar"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const NavBarHandler = _ref => {
  let {
    data,
    innerPageNavData = {},
    history,
    applicationData = {},
    saveLanguage = () => {},
    navCTAOverride,
    Link,
    searchComponent,
    searchDeployed,
    setSearchDeployed,
    navigate,
    globalSearch,
    setGlobalSearch,
    showJumpNav,
    jumpNavItems,
    navRef,
    isCartFlyoutOpen = false,
    onCartFlyoutOpen,
    cartData,
    cartSettings,
    onCartRemoveItem,
    onCartChangeQuantity,
    onPageNavData,
    megaNavVariant
  } = _ref;
  const [languageSelectorDeployed, setLanguageSelectorDeployed] = (0, _react.useState)(false);
  const languageEnabled = applicationData?.languageEnabled;
  const [sectorFlyoutOpen, setSectorFlyoutOpen] = (0, _react.useState)(false);
  const searchSubmit = string => {
    if (string && string.length && history) {
      const languageCode = data?.language?.substring(0, 2);
      const url = languageEnabled ? `/${languageCode}/search?${string}` : `/search?${string}`;
      history.push(url);
      return;
    } else if (string && string.length) {
      // Do Gatsby push w/e
      // TODO - Figure out Gatsby push for Search Submit
    }
  };
  const handleLanguageSelectorDeployed = languageDeployed => {
    setLanguageSelectorDeployed(languageDeployed === undefined ? !languageSelectorDeployed : languageDeployed);
  };
  const handleSectorFlyoutDeployed = flyoutDeployed => {
    setSectorFlyoutOpen(flyoutDeployed === undefined ? !sectorFlyoutOpen : flyoutDeployed);
  };
  const searchFlyoutSubmit = string => {
    if (string && string.length) {
      // TODO - Figure out Gatsby push for Search Flyout Submit
    }
  };
  const megaNavVariantSetting = megaNavVariant === true ? true : false;
  return /*#__PURE__*/_react.default.createElement(_NavBar.default, {
    Link: Link,
    featuredLink: data?.featuredLink //Main nav bar: feature link
    ,
    isExpanded: data?.isExpanded //Main nav bar: if isExpanded this is a sector nav
    ,
    navOptions: data?.navOptions //Main nav bar: data (links or categories)
    ,
    rightLinks: data?.rightLinks //Utility nav bar: right links
    ,
    divisionName: data?.divisionName //Utility nav bar: division name
    ,
    logo: data?.logo //Utility nav bar: logo
    ,
    disableSearch: data?.disableSearch //Utility nav bar: disable search
    ,
    disableLogin: data?.disableLogin //Utility nav bar: disable login
    ,
    disableLanguageRegion: data?.disableLanguageRegion //Utility nav bar: disable region language selector
    ,
    disableSectorFlyOut: data?.disableSectorFlyOut,
    navCTA: navCTAOverride?.link?.url && navCTAOverride?.link?.text ? navCTAOverride : data.navCTA,
    searchSubmit: searchSubmit,
    subNavData: innerPageNavData,
    handleSectorFlyoutDeployed: handleSectorFlyoutDeployed,
    sectorFlyoutDeployed: sectorFlyoutOpen,
    sectorFlyoutData: data?.sectorFlyoutData,
    searchFlyoutSubmit: searchFlyoutSubmit,
    languageSelectorData: data?.languageSelectorData,
    languageSelectorDeployed: languageSelectorDeployed,
    handleLanguageSelectorDeployed: handleLanguageSelectorDeployed,
    saveLanguage: saveLanguage,
    searchComponent: searchComponent,
    searchDeployed: searchDeployed,
    setSearchDeployed: setSearchDeployed,
    loginPage: () => data?.loginPage(),
    logout: () => data?.logout(),
    isAuthenticated: data?.isAuthenticated,
    userProfile: data?.userProfile,
    disableMenus: data?.disableMenus,
    displayIcons: data?.displayIcons,
    displaySectorName: data?.displaySectorName,
    menuBarTheme: data?.menuBarTheme,
    topNavTheme: data?.topNavTheme,
    navigate: navigate,
    authLabels: data?.authLabels,
    setGlobalSearch: setGlobalSearch,
    globalSearch: globalSearch,
    waffleMenu: data?.waffleMenu,
    showJumpNav: showJumpNav,
    jumpNavItems: jumpNavItems,
    navRef: navRef,
    disableCartFlyout: data?.disableCartFlyout,
    isCartFlyoutOpen: isCartFlyoutOpen,
    onCartFlyoutOpen: onCartFlyoutOpen,
    cartSettings: cartSettings,
    cartData: cartData,
    onCartRemoveItem: onCartRemoveItem,
    onCartChangeQuantity: onCartChangeQuantity,
    onPageNavData: onPageNavData,
    megaNavVariant: megaNavVariantSetting
  });
};
var _default = NavBarHandler;
exports.default = _default;